import(/* webpackMode: "eager" */ "/home/runner/work/apollo/apollo/node_modules/.pnpm/next@14.2.3_@babel+core@7.23.9_@opentelemetry+api@1.7.0_@playwright+test@1.48.2_react-dom@18.2.0_react@18.2.0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/apollo/apollo/packages/core/ui/src/atoms/link/link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Tooltip"] */ "/home/runner/work/apollo/apollo/packages/core/ui/src/molecules/tooltip/tooltip.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderSidebar"] */ "/home/runner/work/apollo/apollo/packages/core/ui/src/organisms/header/header-sidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Accordion"] */ "/home/runner/work/apollo/apollo/packages/core/ui/src/templates/accordion/accordion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Logout"] */ "/home/runner/work/apollo/apollo/packages/features/authentication/src/presentation/atoms/logout/logout.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/apollo/apollo/packages/shells/shared/src/presentation/atoms/fullstory-script/fullstory-script.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/apollo/apollo/packages/shells/shared/src/presentation/atoms/metrics-subscription/metrics-subscription.tsx");
